import { useMemo } from "react";

import { CustomCarrierCodes } from "@jti/commerce/shared";
import { useSelector } from "@jti/store/reduxHooks";
import { selectShippingMethods } from "@jti/store/selectors/selectShippingMethods";
import {
  fetchCartPrices,
  fetchTrialCartPrices,
  setFreeTrialShippingMethodsOnCart,
  setShippingMethodsOnCart,
} from "@jti/store/slices/cartSlice";
import {
  getDefaultShippingMethods,
  getFreeTrialDefaultShippingMethods,
  placeFreeTrialOrder,
  placeOrder,
} from "@jti/store/slices/LEGACY__checkoutSlice";

import { useFreeTrial } from "@checkout/hooks/useFreeTrial";

const useDelivery = () => {
  const { isFreeTrial, freeTrialId } = useFreeTrial();
  const isSetFreeTrialsShippingMethodsOnCartPending = useSelector(
    (state) => state.freeTrialCart.checkout.setShippingMethodsOnCartPending
  );
  const isSetShippingMethodsOnCartPending = useSelector((state) => state.checkout.setShippingMethodsOnCartPending);
  const shippingMethods = useSelector((state) => selectShippingMethods(state, isFreeTrial));
  const cartId = useSelector((state) => state.cart.id);
  const placingOrder = useSelector((state) => state.checkout.placingOrder);
  const placingFreeTrialOrder = useSelector((state) => state.freeTrialCart.checkout.orderPending);
  const trialCartPrices = useSelector((state) => state.freeTrialCart.prices);
  const standardCartPrices = useSelector((state) => state.cart.prices);
  const hasFreeTrialOrderError = useSelector((state) => state.freeTrialCart.checkout.hasOrderError);
  const filteredShippingMethods = useMemo(
    () => shippingMethods.data.filter(({ carrierCode }) => carrierCode !== CustomCarrierCodes.jtiPickup),
    [shippingMethods.data]
  );

  return {
    isFreeTrial,
    cartId: isFreeTrial ? freeTrialId : cartId,
    filteredShippingMethods,
    shippingMethods,
    getDefaultShippingMethods: isFreeTrial ? getFreeTrialDefaultShippingMethods : getDefaultShippingMethods,
    setShippingMethods: isFreeTrial ? setFreeTrialShippingMethodsOnCart : setShippingMethodsOnCart,
    setShippingMethodsOnCartPending: isFreeTrial
      ? isSetFreeTrialsShippingMethodsOnCartPending
      : isSetShippingMethodsOnCartPending,
    getPrices: isFreeTrial ? fetchTrialCartPrices : fetchCartPrices,
    placingOrder: isFreeTrial ? placingFreeTrialOrder : placingOrder,
    placeOrderAction: isFreeTrial ? placeFreeTrialOrder : placeOrder,
    priceFetchStatus: isFreeTrial ? trialCartPrices.fetchStatus : standardCartPrices.fetchStatus,
    hasOrderError: isFreeTrial ? hasFreeTrialOrderError : false,
  };
};

export default useDelivery;
